<template>
  <div class="card mt-2">
    <div class="card-header">
      <i class="fa fa-address-book-o"></i> Novo
      Ssv 2341 Confi Crtor Flag Ws
    </div>

    <b-form ref="form" @submit.prevent="onSubmit" @reset="onReset">

      <ssv2341-confi-crtor-flag-ws-form :ssv2341ConfiCrtorFlagWs="ssv2341ConfiCrtorFlagWs" :violations="violations"></ssv2341-confi-crtor-flag-ws-form>

      <div class="row">
        <div class="form-group col-sm-12 mb-2 mr-1 text-right">
          <button class="btn-sm btn btn-sm btn-outline-success mr-1" type="submit" data-toggle="tooltip" data-placement="bottom" title="Salvar">
            <i class="fa fa-floppy-o"></i> Salvar
          </button>

          <button class="btn btn-sm btn-outline-danger mr-1" type="button" data-toggle="tooltip" data-placement="bottom" title="Limpar" @click="onReset()">
            <i class="fa fa-eraser"></i> Limpar
          </button>

          <button class="btn btn-sm btn-outline-dark mr-1" type="button" data-toggle="tooltip" data-placement="bottom" @click="$router.go(-1)" title="Voltar">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex";
  
  import store from "@/store";
  
  import {  
    CREATE_SSV2341_CONFI_CRTOR_FLAG_WS,  
    RESET_SSV2341_CONFI_CRTOR_FLAG_WS
  } from "@/store/actions.type";
  
  import Ssv2341ConfiCrtorFlagWsForm from '@/components/Ssv2341ConfiCrtorFlagWsForm';
  
  export default {
    components: {
      Ssv2341ConfiCrtorFlagWsForm
    },
  
    data() {
      return {
  	 violations: {},
       responseMessage: null,
       successORError: null,
      };
    },
  
    computed: {
      ...mapGetters(['ssv2341ConfiCrtorFlagWs'])
    },
  
    methods: {
      onSubmit() {
        this.violations = {};
        return this.$store.dispatch(CREATE_SSV2341_CONFI_CRTOR_FLAG_WS)
          .then(ssv2341ConfiCrtorFlagWs => {
          	 this.flash().destroyAll();
               this.flashSuccess("Registro criado com sucesso.");
               this.$router.push({
                   name: 'ssv2341-confi-crtor-flag-ws-edit',
                   params: { id: ssv2341ConfiCrtorFlagWs.idConfiCrtorWs + '-' + ssv2341ConfiCrtorFlagWs.cdFlagWs }
               });
              store.dispatch(RESET_SSV2341_CONFI_CRTOR_FLAG_WS);
          })
          .catch(response => {
            this.flash().destroyAll();
            this.flashError("Ocorreu um erro ao tentar realizar cadastro.");
            if (response.body.violations) this.violations = response.body.violations;
            throw response.body.message;
          });
      },
      onReset() {
        this.violations = {};
        store.dispatch(RESET_SSV2341_CONFI_CRTOR_FLAG_WS);
      }
    },
  
    async beforeRouteEnter(to, from, next) {
      await store.dispatch(RESET_SSV2341_CONFI_CRTOR_FLAG_WS);
      return next();
    }
  };
</script>